import { Linked } from '@type-r/models';
import * as React from 'react';
import { InvoiceModel, InvoiceActionType } from 'api/invoice';
import { UploadDialog } from 'common/attachments';
import { DisputeInvoiceDialog } from './dispute';
import { ApproveInvoiceDialog } from './approve';
import { EscalateInternallyDialog } from './escalateInternally';
import { UpdateDialog } from './update';
import { RejectDialog } from './reject';
import { SendBackDialog } from './sendBack';
import { CloseInvoicesDialog } from '../../dialogs/close';
import { EmailInvoiceDialog } from './email-invoice';
import { CommentDialog } from './comment';
import { InternalStatusDialog } from './internal-status';

// export type DialogType = "reset" | "validate" | "upload" | "submit" | "hold" | "cancel";
export type DialogType = "comment" | "email-invoice" | 'upload' | InvoiceActionType | 'internalStatus';
export const ShowDialog = ({ $dialog, invoice, disputedInvoice, prevInvoice }: {
    $dialog: Linked<DialogType>,
    invoice: InvoiceModel,
    disputedInvoice: InvoiceModel,
    prevInvoice: InvoiceModel
}) => {
    switch ($dialog.value) {
        case 'upload':
            return <UploadDialog
                $isOpen={$dialog.equals('upload')}
                model={invoice}
            />;

        case "dispute":
            return <DisputeInvoiceDialog
                $isOpen={$dialog.equals('dispute')}
                invoice={invoice}
                disputedInvoice={disputedInvoice}
                prevInvoice={prevInvoice}
            />;

        case "approve":
            return <ApproveInvoiceDialog
                $isOpen={$dialog.equals('approve')}
                invoice={invoice}
                disputedInvoice={disputedInvoice}
                prevInvoice={prevInvoice}
            />;

        case "escalateInternally":
            return <EscalateInternallyDialog
                $isOpen={$dialog.equals('escalateInternally')}
                invoice={invoice}
                disputedInvoice={disputedInvoice}
                prevInvoice={prevInvoice}
            />;

        case "update":
            return <UpdateDialog
                $isOpen={$dialog.equals('update')}
                invoice={invoice}
                disputedInvoice={disputedInvoice}
                prevInvoice={prevInvoice}
            />;

        case "reject":
            return <RejectDialog
                $isOpen={$dialog.equals('reject')}
                invoice={invoice}
                disputedInvoice={disputedInvoice}
                prevInvoice={prevInvoice}
            />;

        case "sendBack":
            return <SendBackDialog
                $isOpen={$dialog.equals('sendBack')}
                invoice={invoice}
                disputedInvoice={disputedInvoice}
                prevInvoice={prevInvoice}
            />;

        case 'close':
            return <CloseInvoicesDialog
                $isOpen={$dialog.equals('close')}
                invoices={[invoice]}
            />;

        case 'email-invoice':
            return <EmailInvoiceDialog
                $isOpen={$dialog.equals('email-invoice')}
                invoice={invoice}
            />;
        case 'comment':
            return <CommentDialog
                $isOpen={$dialog.equals('comment')}
                invoice={invoice}
            />;
        case 'internalStatus':
            return <InternalStatusDialog
                $isOpen={$dialog.equals('internalStatus')}
                invoice={invoice}
            />;
        default:
            return <div />
    }
}
